module.exports = __webpack_public_path__ + "static/media/basketball-hoop.eb82162a.svg";